import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

// Shell of the area that opens to the right of the menu bar: a fixed-width
// column spanning the full height, with the menu title top left and the
// close arrow top right.
const WorkspacePanel = ({ title, onClose, children }) => (
  <Box
    sx={{
      // Geometry comes from .workspace-panel-host, which positions and
      // animates the panel over the map.
      width: '100%',
      height: '100%',
      backgroundColor: '#ffffff',
      borderRight: '1px solid #cfd8dc',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      boxShadow: '2px 0 6px rgba(0,0,0,0.08)',
      position: 'relative',
      zIndex: 1100,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 1.25,
        borderBottom: '1px solid #e0e0e0',
        flexShrink: 0,
      }}
    >
      <Typography variant="h6" sx={{ fontSize: '17px', fontWeight: 600 }}>
        {title}
      </Typography>
      <Tooltip title="Menü schließen">
        <IconButton size="small" onClick={onClose} aria-label="Menü schließen">
          <ChevronLeftIcon />
        </IconButton>
      </Tooltip>
    </Box>

    <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>{children}</Box>
  </Box>
);

export default WorkspacePanel;
